/**
 * Client-side tag filtering for the blog stories section.
 */
class BlogStoriesFilter extends HTMLElement {
  connectedCallback() {
    this.#disableEmptyFilters();
    this.#bindFilters();
  }

  #availableTags() {
    const tags = new Set();

    this.querySelectorAll('[data-blog-tags]').forEach((card) => {
      (card.dataset.blogTags || '')
        .split(' ')
        .filter(Boolean)
        .forEach((tag) => tags.add(tag));
    });

    return tags;
  }

  #disableEmptyFilters() {
    const availableTags = this.#availableTags();

    this.querySelectorAll('[data-blog-filter]').forEach((button) => {
      const filter = button.dataset.blogFilter;
      if (!filter || filter === 'all') return;

      const hasMatch = availableTags.has(filter);
      button.disabled = !hasMatch;
      button.classList.toggle('is-disabled', !hasMatch);
      button.setAttribute('aria-disabled', hasMatch ? 'false' : 'true');
    });
  }

  #bindFilters() {
    const filters = this.querySelectorAll('[data-blog-filter]');
    const cards = this.querySelectorAll('[data-blog-tags]');

    if (!filters.length || !cards.length) return;

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;

        const activeFilter = button.dataset.blogFilter;

        filters.forEach((filterButton) => {
          filterButton.classList.toggle('is-active', filterButton === button);
          filterButton.setAttribute('aria-pressed', filterButton === button ? 'true' : 'false');
        });

        cards.forEach((card) => {
          if (activeFilter === 'all') {
            card.hidden = false;
            return;
          }

          const tags = (card.dataset.blogTags || '').split(' ').filter(Boolean);
          card.hidden = !tags.includes(activeFilter);
        });
      });
    });
  }
}

if (!customElements.get('blog-stories-filter')) {
  customElements.define('blog-stories-filter', BlogStoriesFilter);
}
